"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6609],{

/***/ 39512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84857);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22519);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var ContentTopContainer = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return ![
            "isWPA",
            "isSearchPage"
        ].includes(prop);
    }
})(function(param) {
    var theme = param.theme, _isWPA = param.isWPA, isWPA = _isWPA === void 0 ? false : _isWPA, _isSearchPage = param.isSearchPage, isSearchPage = _isSearchPage === void 0 ? false : _isSearchPage;
    var _obj;
    return _obj = {
        paddingLeft: "".concat(theme.spacing(5)),
        paddingRight: "".concat(theme.spacing(5)),
        marginTop: isWPA ? "16px" : 0,
        maxWidth: theme.breakpoints.values.xl,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center"
    }, _defineProperty(_obj, theme.breakpoints.down("xl"), {
        paddingLeft: "".concat(theme.spacing(4)),
        paddingRight: "".concat(theme.spacing(4))
    }), _defineProperty(_obj, theme.breakpoints.down("lg"), {
        boxSizing: "border-box",
        maxWidth: theme.breakpoints.values.sm,
        paddingLeft: "".concat(theme.spacing(0)),
        paddingRight: "".concat(theme.spacing(0))
    }), _defineProperty(_obj, theme.breakpoints.down("md"), {
        paddingLeft: "".concat(theme.spacing(isSearchPage ? 0 : 2)),
        paddingRight: "".concat(theme.spacing(isSearchPage ? 0 : 2))
    }), _obj;
});
/* harmony default export */ __webpack_exports__["Z"] = (ContentTopContainer);


/***/ }),

/***/ 77225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D6": function() { return /* binding */ CONNECTION_COUNT_TRUST_BADGE_PRACTICE; },
/* harmony export */   "FP": function() { return /* binding */ endpoint; },
/* harmony export */   "FS": function() { return /* binding */ SpecialistPlans; },
/* harmony export */   "Gw": function() { return /* binding */ limitReviews; },
/* harmony export */   "JG": function() { return /* binding */ limitSpecialists; },
/* harmony export */   "LB": function() { return /* binding */ AreasSortingTabs; },
/* harmony export */   "Mm": function() { return /* binding */ LAST_KEYWORD_IN_AREA_OF_EXPERTISE; },
/* harmony export */   "PE": function() { return /* binding */ limitReviewsOnReviewPage; },
/* harmony export */   "Tr": function() { return /* binding */ MediaTypes; },
/* harmony export */   "cj": function() { return /* binding */ PracticePlans; },
/* harmony export */   "hY": function() { return /* binding */ RequestSources; },
/* harmony export */   "hn": function() { return /* binding */ pathMap; },
/* harmony export */   "iJ": function() { return /* binding */ doctifyProviderDomain; },
/* harmony export */   "kh": function() { return /* binding */ mediaTypesWithoutSocials; },
/* harmony export */   "ku": function() { return /* binding */ ONLINE; },
/* harmony export */   "lO": function() { return /* binding */ RequestTypes; },
/* harmony export */   "qB": function() { return /* binding */ SortingOptions; },
/* harmony export */   "ub": function() { return /* binding */ ProfileTypes; },
/* harmony export */   "w": function() { return /* binding */ CONNECTION_COUNT_TRUST_BADGE_SPECIALIST; }
/* harmony export */ });
/* unused harmony exports SocialMediaTypes, limitEndorsements, REVIEWS_HASH */
var doctifyProviderDomain = "https://provider.doctify.com";
var endpoint = "/entry-tier";
var pathMap = {
    uk: "/en-gb/uk",
    ae: "/en-ae/ae",
    "en-ae": "/en-ae/ae",
    "ar-ae": "/en-ae/ae",
    at: "/de-at/at",
    "de-at": "/de-at/at",
    de: "/de-de/de",
    au: "/en-au/aus",
    ie: "/en-ie/ie",
    wpa: "/en-gb/uk"
};
var limitReviews = 10;
var limitReviewsOnReviewPage = 10;
var limitEndorsements = 10;
var limitSpecialists = 12;
var SpecialistPlans;
(function(SpecialistPlans) {
    SpecialistPlans["ENTRY"] = "s_freemium";
    SpecialistPlans["EXPERT"] = "s_expert";
    SpecialistPlans["EXPERT_PRO"] = "s_pro";
    SpecialistPlans["UNCLAIMED"] = "unclaimed";
    SpecialistPlans["NO_PLAN"] = "no plan";
})(SpecialistPlans || (SpecialistPlans = {}));
var PracticePlans;
(function(PracticePlans) {
    PracticePlans["ENTRY"] = "p_freemium";
    PracticePlans["STARTER"] = "p_starter";
    PracticePlans["ESSENTIALS"] = "p_essentials";
    PracticePlans["PRO"] = "p_pro";
    PracticePlans["UNCLAIMED"] = "unclaimed";
    PracticePlans["NO_PLAN"] = "no plan";
})(PracticePlans || (PracticePlans = {}));
var MediaTypes;
(function(MediaTypes) {
    MediaTypes["WEBSITE"] = "website";
    MediaTypes["PUBLICATION"] = "publication";
    MediaTypes["VIDEO"] = "video";
    MediaTypes["PROFILE"] = "profile";
    MediaTypes["ARTICLE"] = "article";
})(MediaTypes || (MediaTypes = {}));
var SocialMediaTypes;
(function(SocialMediaTypes) {
    SocialMediaTypes["TIKTOK"] = "tiktok";
    SocialMediaTypes["INSTAGRAM"] = "instagram";
    SocialMediaTypes["TWITTER"] = "twitter";
    SocialMediaTypes["FACEBOOK"] = "facebook";
})(SocialMediaTypes || (SocialMediaTypes = {}));
var mediaTypesWithoutSocials = [
    "video",
    "profile",
    "article",
    "publication",
    "website"
];
var CONNECTION_COUNT_TRUST_BADGE_SPECIALIST = 20;
var CONNECTION_COUNT_TRUST_BADGE_PRACTICE = 100;

var REVIEWS_HASH = "#reviews";
var AreasSortingTabs;
(function(AreasSortingTabs) {
    AreasSortingTabs["REVIEWS"] = "reviews";
    AreasSortingTabs["ENDORSEMENTS"] = "endorsements";
    AreasSortingTabs["ALPHABET"] = "alphabet";
})(AreasSortingTabs || (AreasSortingTabs = {}));
var SortingOptions;
(function(SortingOptions) {
    SortingOptions["ALPHABET"] = "AlphabetSorting";
    SortingOptions["REVIEWS"] = "ReviewsSorting";
    SortingOptions["ENDORSEMENTS"] = "EndorsementsSorting";
})(SortingOptions || (SortingOptions = {}));
var RequestTypes;
(function(RequestTypes) {
    RequestTypes["PHONE"] = "Phone";
    RequestTypes["EMAIL"] = "Email";
    RequestTypes["EXTERNAL_BOOKING_LINK"] = "ExternalBookingLink";
})(RequestTypes || (RequestTypes = {}));
var RequestSources;
(function(RequestSources) {
    RequestSources["DESKTOP"] = "Desktop";
    RequestSources["MOBILE"] = "Mobile";
})(RequestSources || (RequestSources = {}));
var ONLINE = "online";
var ProfileTypes;
(function(ProfileTypes) {
    ProfileTypes["PRACTICE"] = "practice";
    ProfileTypes["SPECIALIST"] = "specialist";
})(ProfileTypes || (ProfileTypes = {}));
var LAST_KEYWORD_IN_AREA_OF_EXPERTISE = "last-keyword-in-area-of-expertise";


/***/ }),

/***/ 97014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HB": function() { return /* binding */ AMOUNT_KEYWORDS; },
/* harmony export */   "Nw": function() { return /* binding */ PROFILE_REVIEW_TOTAL_LIMIT; },
/* harmony export */   "Sw": function() { return /* binding */ FILTERS_TO_EXCLUDE_FROM_BREADCRUMBS; },
/* harmony export */   "Vn": function() { return /* binding */ AppointmentType; },
/* harmony export */   "XD": function() { return /* binding */ DEFAULT_SEARCH_DISTANCE; },
/* harmony export */   "f0": function() { return /* binding */ AMOUNT_KEYWORDS_WPA; },
/* harmony export */   "pf": function() { return /* binding */ AU_SEARCH_DISTANCE; },
/* harmony export */   "vA": function() { return /* binding */ FilterType; },
/* harmony export */   "wo": function() { return /* binding */ NUMBER_PER_PROFILE_REQUEST; },
/* harmony export */   "yu": function() { return /* binding */ KeyTypes; }
/* harmony export */ });
/* unused harmony exports YOUR_LOCATION_ALIAS, SEARCH_FILTERS */
var NUMBER_PER_PROFILE_REQUEST = 10;
var YOUR_LOCATION_ALIAS = "Your location";
var KeyTypes = {
    email: "mailto:",
    phone: "tel:",
    externalBookingLink: ""
};
var AppointmentType;
(function(AppointmentType) {
    AppointmentType["VIDEO_CONSULTATION"] = "videoConsultation";
})(AppointmentType || (AppointmentType = {}));
var FilterType;
(function(FilterType) {
    FilterType["VIDEO_CONSULTATION"] = "video-consultation";
})(FilterType || (FilterType = {}));
var DEFAULT_SEARCH_DISTANCE = "25";
var AU_SEARCH_DISTANCE = "70";
var PROFILE_REVIEW_TOTAL_LIMIT = 10;
var AMOUNT_KEYWORDS = 1;
var AMOUNT_KEYWORDS_WPA = 3;
var SEARCH_FILTERS = {
    DISTANCE: "distance"
};
var FILTERS_TO_EXCLUDE_FROM_BREADCRUMBS = [
    SEARCH_FILTERS.DISTANCE
];


/***/ }),

/***/ 19837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cK": function() { return /* binding */ unclaimedTags; },
  "kx": function() { return /* binding */ useGetContactsData; },
  "G9": function() { return /* binding */ useGetSearchProfileData; }
});

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ./utils/address.ts
var address = __webpack_require__(46699);
// EXTERNAL MODULE: ./utils/date.ts
var date = __webpack_require__(12814);
// EXTERNAL MODULE: ./utils/getAbbreviation.ts
var getAbbreviation = __webpack_require__(76868);
// EXTERNAL MODULE: ./constants/search.ts
var search = __webpack_require__(97014);
;// CONCATENATED MODULE: ./utils/getContacts.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var getPracticeContacts = function(param1) {
    var practiceProfile = param1.practiceProfile, specialistPractice = param1.specialistPractice, shouldUsePracticeContacts = param1.shouldUsePracticeContacts;
    if (practiceProfile) {
        var phone = practiceProfile.phone, email = practiceProfile.email, externalBookingLink = practiceProfile.externalBookingLink;
        return {
            phone: phone,
            email: email,
            externalBookingLink: externalBookingLink
        };
    }
    if (specialistPractice) {
        var ref = (specialistPractice.ContactDetails || []).reduce(function(prev, param) {
            var p = param.phone, e = param.email;
            return {
                phone: p || prev.phone,
                email: e || prev.email
            };
        }, {
            phone: "",
            email: ""
        }), phone1 = ref.phone, email1 = ref.email;
        var externalBookingLink1 = specialistPractice.externalBookingLink, contactDetailsPractice = specialistPractice.contactDetailsPractice;
        return {
            phone: shouldUsePracticeContacts ? contactDetailsPractice === null || contactDetailsPractice === void 0 ? void 0 : contactDetailsPractice.phone : phone1,
            email: shouldUsePracticeContacts ? contactDetailsPractice === null || contactDetailsPractice === void 0 ? void 0 : contactDetailsPractice.email : email1,
            externalBookingLink: externalBookingLink1
        };
    }
};
var mapContact = function(key, specialistPractices) {
    return specialistPractices.reduce(function(prev, curr) {
        var ref;
        var contact = getPracticeContacts({
            specialistPractice: curr
        });
        if (!(contact === null || contact === void 0 ? void 0 : (ref = contact[key]) === null || ref === void 0 ? void 0 : ref.length)) {
            return prev;
        }
        return _toConsumableArray(prev).concat([
            {
                link: "".concat(search/* KeyTypes */.yu[key]).concat(contact[key]),
                practice: curr
            }
        ]);
    }, []);
};
var mapSpecialistPracticesContacts = function(specialistPractices) {
    return {
        practicesWithEmails: mapContact("email", specialistPractices),
        practicesWithPhones: mapContact("phone", specialistPractices),
        practicesWithExternalBookingLinks: mapContact("externalBookingLink", specialistPractices)
    };
};

// EXTERNAL MODULE: ./constants/profile.ts
var profile = __webpack_require__(77225);
// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(63040);
// EXTERNAL MODULE: ./providers/AppData/Profile/index.tsx
var Profile = __webpack_require__(4527);
// EXTERNAL MODULE: ./utils/strings.ts
var strings = __webpack_require__(43601);
// EXTERNAL MODULE: ./hooks/useGetUnitsByLocale.ts
var useGetUnitsByLocale = __webpack_require__(87691);
// EXTERNAL MODULE: ./constants/global.ts
var global = __webpack_require__(76467);
;// CONCATENATED MODULE: ./hooks/useGetProfileData.ts












var unclaimedTags = [
    profile/* PracticePlans.NO_PLAN */.cj.NO_PLAN,
    profile/* PracticePlans.UNCLAIMED */.cj.UNCLAIMED,
    profile/* SpecialistPlans.NO_PLAN */.FS.NO_PLAN,
    profile/* SpecialistPlans.UNCLAIMED */.FS.UNCLAIMED
];
var entryTags = [
    profile/* PracticePlans.ENTRY */.cj.ENTRY,
    profile/* SpecialistPlans.ENTRY */.FS.ENTRY
];
var useGetSearchProfileData = function(param) {
    var practice1 = param.practice, specialist = param.specialist, language = param.language, specialty = param.specialty;
    var getUnitsByLocale = (0,useGetUnitsByLocale/* useGetUnitsByLocale */.N)();
    var locale = (0,react.useContext)(AppData/* AppDataContext */.R).locale;
    // todo: fix complexity
    // eslint-disable-next-line complexity
    return (0,react.useMemo)(function() {
        var ref16, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
        var isUnclaimed = unclaimedTags.some(function(tag) {
            var ref, ref15;
            return (ref = practice1 || specialist) === null || ref === void 0 ? void 0 : (ref15 = ref.plan) === null || ref15 === void 0 ? void 0 : ref15.includes(tag);
        });
        var isEntry = entryTags.some(function(tag) {
            var ref, ref17;
            return (ref = practice1 || specialist) === null || ref === void 0 ? void 0 : (ref17 = ref.plan) === null || ref17 === void 0 ? void 0 : ref17.includes(tag);
        });
        var isPractice = !!practice1;
        var haveVideoConsultation = specialist === null || specialist === void 0 ? void 0 : (ref16 = specialist.practices) === null || ref16 === void 0 ? void 0 : ref16.some(function(practiceItem) {
            return (practiceItem === null || practiceItem === void 0 ? void 0 : practiceItem.slug) === search/* FilterType.VIDEO_CONSULTATION */.vA.VIDEO_CONSULTATION;
        });
        var slug = (specialist === null || specialist === void 0 ? void 0 : specialist.slug) || (practice1 === null || practice1 === void 0 ? void 0 : practice1.slug) || "";
        var profileAbbreviation = practice1 && (0,getAbbreviation/* getAbbreviation */.T)({
            practice: practice1,
            language: language
        }) || specialist && (0,getAbbreviation/* getAbbreviation */.T)({
            specialist: specialist,
            language: language
        }) || "";
        var ref13;
        var profileFullName = (0,strings/* removeSpecificSymbols */.i)(isPractice ? practice1.name[language] : "".concat((ref13 = specialist === null || specialist === void 0 ? void 0 : (ref1 = specialist.title) === null || ref1 === void 0 ? void 0 : ref1[language]) !== null && ref13 !== void 0 ? ref13 : "", " ").concat(specialist === null || specialist === void 0 ? void 0 : specialist.fullName[language]).trim() || "");
        var keywords = isPractice ? practice1.keywords : (specialist === null || specialist === void 0 ? void 0 : specialist.keywords) || [];
        var id = isPractice ? practice1.id : (specialist === null || specialist === void 0 ? void 0 : specialist.id) || 0;
        var topLevelKeyword = keywords === null || keywords === void 0 ? void 0 : keywords.filter(function(keyword) {
            var ref;
            if ((specialty === null || specialty === void 0 ? void 0 : specialty.type) === "specialty" && specialty.slug[0] === ((ref = keyword.slug) === null || ref === void 0 ? void 0 : ref[0])) {
                return specialty.slug[0] === keyword.slug[0] && keyword.isTopLevelChild && keyword.keywordType === "specialty";
            }
            return keyword.isTopLevelChild && keyword.keywordType === "specialty";
        }).map(function(keyword) {
            var ref;
            return (keyword === null || keyword === void 0 ? void 0 : (ref = keyword.practitioner) === null || ref === void 0 ? void 0 : ref[language]) || (keyword === null || keyword === void 0 ? void 0 : keyword.name[language]);
        })[0];
        var profileAvatarLink = isPractice ? (practice1 === null || practice1 === void 0 ? void 0 : (ref2 = practice1.images) === null || ref2 === void 0 ? void 0 : ref2.cover) || (practice1 === null || practice1 === void 0 ? void 0 : (ref3 = practice1.images) === null || ref3 === void 0 ? void 0 : ref3.logo) || "" : (specialist === null || specialist === void 0 ? void 0 : (ref4 = specialist.images) === null || ref4 === void 0 ? void 0 : ref4.logo) || "";
        var subKeywords = (keywords === null || keywords === void 0 ? void 0 : keywords.filter(function(k) {
            return !k.isTopLevelChild;
        })) || [];
        var procedures = subKeywords.filter(function(keyword) {
            return keyword.keywordType === "procedure";
        });
        var yearsOfExperienceValue = (0,date/* getYearsDiff */.qW)((specialist === null || specialist === void 0 ? void 0 : specialist.yearsOfExperience) || "");
        var contacts = isPractice && getPracticeContacts({
            practiceProfile: practice1
        }) || null;
        var latestReview = practice1 ? practice1 === null || practice1 === void 0 ? void 0 : practice1.lastReview : specialist === null || specialist === void 0 ? void 0 : specialist.lastReview;
        var latestReviewPractice = (specialist === null || specialist === void 0 ? void 0 : (ref5 = specialist.lastReview) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.practice) === null || ref6 === void 0 ? void 0 : ref6.name[language]) || null;
        var profileReviewTotal = isPractice ? practice1.reviewsTotal : (specialist === null || specialist === void 0 ? void 0 : specialist.reviewsTotal) || 0;
        var averageRating = practice1 ? practice1 === null || practice1 === void 0 ? void 0 : practice1.averageRating : specialist === null || specialist === void 0 ? void 0 : specialist.averageRating;
        var distance = (practice1 === null || practice1 === void 0 ? void 0 : practice1.distance) || ((ref7 = specialist === null || specialist === void 0 ? void 0 : specialist.practices.filter(function(x) {
            return x.slug !== "video-consultation";
        }).sort(function(a, b) {
            return a.distance - b.distance;
        })) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : ref8.distance) || 0;
        var formattedDistance = getUnitsByLocale(distance, 2);
        var transformedAddress = (specialist === null || specialist === void 0 ? void 0 : specialist.address) && (specialist === null || specialist === void 0 ? void 0 : specialist.type) === "homecare" && (0,address/* transformHomeCareAddressToString */.wK)(specialist === null || specialist === void 0 ? void 0 : specialist.address, language) || (practice1 === null || practice1 === void 0 ? void 0 : practice1.address) && (0,address/* transformAddressToString */.CU)(practice1 === null || practice1 === void 0 ? void 0 : practice1.address, language, locale !== global/* TENANTS.WPA */.rk.WPA ? formattedDistance.distanceWithUnits : undefined, "|") || "";
        var practices = (specialist === null || specialist === void 0 ? void 0 : specialist.practices) || [];
        var ref14 = (specialist === null || specialist === void 0 ? void 0 : specialist.practices) ? mapSpecialistPracticesContacts(specialist.practices) : {}, _practicesWithEmails = ref14.practicesWithEmails, practicesWithEmails = _practicesWithEmails === void 0 ? [] : _practicesWithEmails, _practicesWithPhones = ref14.practicesWithPhones, practicesWithPhones = _practicesWithPhones === void 0 ? [] : _practicesWithPhones, _practicesWithExternalBookingLinks = ref14.practicesWithExternalBookingLinks, practicesWithExternalBookingLinks = _practicesWithExternalBookingLinks === void 0 ? [] : _practicesWithExternalBookingLinks;
        var isHaveSpecialistPracticesContacts = !!practicesWithEmails.length || !!practicesWithExternalBookingLinks.length || !!practicesWithPhones.length;
        var isHavePracticeContacts = !!(contacts === null || contacts === void 0 ? void 0 : (ref9 = contacts.email) === null || ref9 === void 0 ? void 0 : ref9.length) || !!(contacts === null || contacts === void 0 ? void 0 : (ref10 = contacts.externalBookingLink) === null || ref10 === void 0 ? void 0 : ref10.length) || !!(contacts === null || contacts === void 0 ? void 0 : (ref11 = contacts.phone) === null || ref11 === void 0 ? void 0 : ref11.length);
        var isHaveBookingSlots = !!(specialist === null || specialist === void 0 ? void 0 : (ref12 = specialist.practices) === null || ref12 === void 0 ? void 0 : ref12.some(function(practice) {
            var ref;
            return (ref = practice.slots) === null || ref === void 0 ? void 0 : ref.length;
        }));
        var shouldShowContactButton = isHaveSpecialistPracticesContacts || isHavePracticeContacts || isHaveBookingSlots;
        var externalId = (practice1 === null || practice1 === void 0 ? void 0 : practice1.externalId) || (specialist === null || specialist === void 0 ? void 0 : specialist.externalId) || "";
        return {
            id: id,
            profileAbbreviation: profileAbbreviation,
            profileFullName: profileFullName,
            keywords: keywords,
            topLevelKeyword: topLevelKeyword,
            profileAvatarLink: isUnclaimed || isEntry ? "" : profileAvatarLink,
            subKeywords: subKeywords,
            procedures: procedures,
            isUnclaimed: isUnclaimed,
            yearsOfExperienceValue: yearsOfExperienceValue,
            isPractice: isPractice,
            contacts: contacts,
            latestReview: latestReview,
            latestReviewPractice: latestReviewPractice,
            profileReviewTotal: profileReviewTotal,
            averageRating: averageRating,
            shouldShowContactButton: shouldShowContactButton,
            distance: distance,
            haveVideoConsultation: haveVideoConsultation,
            transformedAddress: transformedAddress,
            practices: practices,
            practicesWithEmails: practicesWithEmails,
            practicesWithPhones: practicesWithPhones,
            practicesWithExternalBookingLinks: practicesWithExternalBookingLinks,
            slug: slug,
            externalId: externalId
        };
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        language,
        practice1,
        specialist
    ]);
};
var useGetContactsData = function(param) {
    var specialistData = param.specialistData, practiceData = param.practiceData;
    var language = (0,react.useContext)(AppData/* AppDataContext */.R).language;
    var ref18 = (0,react.useContext)(Profile/* ProfileContext */.J), practiceProvider = ref18.practice, specialistProvider = ref18.specialist;
    var practice = practiceProvider || practiceData;
    var specialist = specialistProvider || specialistData;
    var practiceContacts = getPracticeContacts({
        practiceProfile: practice
    });
    var externalId = (practice === null || practice === void 0 ? void 0 : practice.externalId) || (specialist === null || specialist === void 0 ? void 0 : specialist.externalId) || "";
    return (0,react.useMemo)(function() {
        var specialistPractices = practice || practiceData ? [
            practice || practiceData
        ] : (specialist === null || specialist === void 0 ? void 0 : specialist.practices) || (specialistData === null || specialistData === void 0 ? void 0 : specialistData.practices) || [];
        var shouldUsePracticeContacts = specialistPractices.map(function(sp) {
            var ref20;
            return (ref20 = sp.ContactDetails) === null || ref20 === void 0 ? void 0 : ref20.every(function(cd) {
                var ref, ref19;
                return !((ref = cd.email) === null || ref === void 0 ? void 0 : ref.length) && !((ref19 = cd.phone) === null || ref19 === void 0 ? void 0 : ref19.length);
            });
        }).every(function(x) {
            return x;
        });
        return specialistPractices// eslint-disable-next-line complexity
        .map(function(specialistPractice) {
            var ref, ref21, ref22, ref23, ref24;
            var contacts = getPracticeContacts({
                specialistPractice: specialistPractice,
                shouldUsePracticeContacts: shouldUsePracticeContacts
            });
            var email = practice ? (practiceContacts === null || practiceContacts === void 0 ? void 0 : practiceContacts.email) || "" : (specialist === null || specialist === void 0 ? void 0 : specialist.useSinglePointOfContact) && specialist.emails[0] || (contacts === null || contacts === void 0 ? void 0 : contacts.email) || "";
            var phone = practice ? (practiceContacts === null || practiceContacts === void 0 ? void 0 : practiceContacts.phone) || "" : (specialist === null || specialist === void 0 ? void 0 : specialist.useSinglePointOfContact) && specialist.phones[0] || (contacts === null || contacts === void 0 ? void 0 : contacts.phone) || "";
            var slug = specialist ? specialist.slug : practice === null || practice === void 0 ? void 0 : practice.slug;
            var bookingSlots = (specialistPractice === null || specialistPractice === void 0 ? void 0 : specialistPractice.slots) || [];
            return {
                profileSlug: slug,
                id: specialistPractice === null || specialistPractice === void 0 ? void 0 : specialistPractice.id,
                externalId: externalId,
                profileName: (practice === null || practice === void 0 ? void 0 : practice.name[language]) || (specialist === null || specialist === void 0 ? void 0 : specialist.fullName[language]) || "",
                contactName: specialistPractice === null || specialistPractice === void 0 ? void 0 : specialistPractice.name[language],
                email: email,
                phone: phone,
                practiceExternalId: specialistPractice === null || specialistPractice === void 0 ? void 0 : specialistPractice.externalId,
                externalBookingLink: (specialist === null || specialist === void 0 ? void 0 : specialist.useSinglePointOfContact) ? specialist.externalBookingLink || (specialistPractice === null || specialistPractice === void 0 ? void 0 : specialistPractice.externalBookingLink) : specialistPractice === null || specialistPractice === void 0 ? void 0 : specialistPractice.externalBookingLink,
                logo: (specialistPractice === null || specialistPractice === void 0 ? void 0 : (ref = specialistPractice.images) === null || ref === void 0 ? void 0 : ref.logo) || "",
                image: (specialistPractice === null || specialistPractice === void 0 ? void 0 : (ref21 = specialistPractice.images) === null || ref21 === void 0 ? void 0 : ref21.cover) || "",
                overallExperience: (practice === null || practice === void 0 ? void 0 : practice.overallExperience) || ((ref22 = specialistPractice.reviews) === null || ref22 === void 0 ? void 0 : ref22.overallExperience),
                reviewsTotal: (practice === null || practice === void 0 ? void 0 : practice.reviewsTotal) || ((ref23 = specialistPractice.reviews) === null || ref23 === void 0 ? void 0 : ref23.reviewsTotal),
                workingOpeningHours: specialistPractice === null || specialistPractice === void 0 ? void 0 : specialistPractice.workingOpeningHours,
                address: specialistPractice === null || specialistPractice === void 0 ? void 0 : specialistPractice.address,
                premium: specialistPractice === null || specialistPractice === void 0 ? void 0 : (ref24 = specialistPractice.customFields) === null || ref24 === void 0 ? void 0 : ref24.premium,
                slug: specialistPractice === null || specialistPractice === void 0 ? void 0 : specialistPractice.slug,
                bookingSlots: bookingSlots
            };
        })// skip contacts with all empty values
        .filter(function(f) {
            return !!f.email || !!f.phone || !!f.externalBookingLink || !!f.bookingSlots.length;
        });
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        practice,
        specialist === null || specialist === void 0 ? void 0 : specialist.practices,
        specialist === null || specialist === void 0 ? void 0 : specialist.fullName,
        specialist === null || specialist === void 0 ? void 0 : specialist.useSinglePointOfContact,
        specialist === null || specialist === void 0 ? void 0 : specialist.emails,
        specialist === null || specialist === void 0 ? void 0 : specialist.phones,
        specialist === null || specialist === void 0 ? void 0 : specialist.externalBookingLink,
        language,
        practiceContacts === null || practiceContacts === void 0 ? void 0 : practiceContacts.email,
        practiceContacts === null || practiceContacts === void 0 ? void 0 : practiceContacts.phone
    ]);
};


/***/ }),

/***/ 87691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useGetUnitsByLocale; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _useTranslateMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57419);
/* harmony import */ var _providers_AppData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63040);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var DEFAULT_SEARCH_DISTANCE_UNITS = "mi";
var unitsMap = {
    mi: "miles",
    km: "kilometres"
};
var getUnits = function(searchDistanceUnits) {
    var queryUnits = searchDistanceUnits && Object.keys(unitsMap).includes(searchDistanceUnits) ? searchDistanceUnits : DEFAULT_SEARCH_DISTANCE_UNITS;
    return {
        units: unitsMap[searchDistanceUnits || DEFAULT_SEARCH_DISTANCE_UNITS],
        queryUnits: queryUnits
    };
};
var parseDistance = function(distance, translatedUnits, units, toFixed) {
    var stringDistance = distance.toString();
    var float = Number.parseFloat(stringDistance).toFixed(toFixed);
    if (Number.isNaN(+float)) {
        return {
            distanceWithUnits: stringDistance,
            distance: stringDistance,
            queryDistance: stringDistance
        };
    }
    return {
        distanceWithUnits: "".concat(float, " ").concat(translatedUnits),
        distance: float,
        queryDistance: "".concat(distance).concat(units.queryUnits)
    };
};
var useGetUnitsByLocale = function() {
    var tenantSettings = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_AppData__WEBPACK_IMPORTED_MODULE_2__/* .AppDataContext */ .R).tenantSettings;
    var translate = (0,_useTranslateMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(distance, toFixed) {
        var parsedDistance = distance || "";
        var units = getUnits(tenantSettings === null || tenantSettings === void 0 ? void 0 : tenantSettings.searchDistanceUnits);
        var translatedUnits = translate(units.units);
        return _objectSpread({}, parseDistance(parsedDistance, translatedUnits, units, toFixed), {
            units: translatedUnits
        });
    }, // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        tenantSettings
    ]);
};


/***/ }),

/***/ 4527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ ProfileContext; },
/* harmony export */   "w": function() { return /* binding */ ProfileContextProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32735);


var ProfileContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var ProfileContextProvider = function(param) {
    var practice = param.practice, specialist = param.specialist, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProfileContext.Provider, {
        value: {
            practice: practice,
            specialist: specialist
        },
        children: children
    });
};



/***/ }),

/***/ 46699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CU": function() { return /* binding */ transformAddressToString; },
/* harmony export */   "WM": function() { return /* binding */ removeVideoConsultation; },
/* harmony export */   "c5": function() { return /* binding */ transformAddressToShortString; },
/* harmony export */   "oB": function() { return /* binding */ transformAddressForSearchToString; },
/* harmony export */   "wK": function() { return /* binding */ transformHomeCareAddressToString; },
/* harmony export */   "zz": function() { return /* binding */ getAddressFromPractices; }
/* harmony export */ });
/* harmony import */ var _constants_global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76467);

var transformAddressToString = function(address, language, distance, separator) {
    var ref = address || {}, street2 = ref.street2, street1 = ref.street1, city = ref.city, country = ref.country, postcode = ref.postcode;
    var isGerman = language.includes("de");
    var germanAddress = [
        street2 === null || street2 === void 0 ? void 0 : street2[language],
        street1 === null || street1 === void 0 ? void 0 : street1[language],
        postcode === null || postcode === void 0 ? void 0 : postcode[language],
        city === null || city === void 0 ? void 0 : city[language],
        country === null || country === void 0 ? void 0 : country[language]
    ].filter(Boolean).join(", ");
    var defaultAddress = [
        street2 === null || street2 === void 0 ? void 0 : street2[language],
        street1 === null || street1 === void 0 ? void 0 : street1[language],
        city === null || city === void 0 ? void 0 : city[language],
        country === null || country === void 0 ? void 0 : country[language],
        postcode === null || postcode === void 0 ? void 0 : postcode[language]
    ].filter(Boolean).join(", ");
    var distanceWithSeparator = "".concat(distance, " ").concat(separator, " ");
    var germanAddressWithDistance = "".concat(distance ? distanceWithSeparator : "").concat(germanAddress);
    var defaultAddressWithDistance = "".concat(distance ? distanceWithSeparator : "").concat(defaultAddress);
    return isGerman ? germanAddressWithDistance : defaultAddressWithDistance;
};
var transformAddressForSearchToString = function(address, language) {
    var ref = address || {}, street2 = ref.street2, street1 = ref.street1, city = ref.city, postcode = ref.postcode;
    var isGerman = language.includes("de");
    var result = isGerman ? [
        street2 === null || street2 === void 0 ? void 0 : street2[language],
        street1 === null || street1 === void 0 ? void 0 : street1[language],
        postcode === null || postcode === void 0 ? void 0 : postcode[language],
        city === null || city === void 0 ? void 0 : city[language]
    ] : [
        street2 === null || street2 === void 0 ? void 0 : street2[language],
        street1 === null || street1 === void 0 ? void 0 : street1[language],
        city === null || city === void 0 ? void 0 : city[language],
        postcode === null || postcode === void 0 ? void 0 : postcode[language]
    ];
    return result.filter(Boolean).join(", ");
};
var transformHomeCareAddressToString = function(address, language) {
    var ref = address || {}, city = ref.city, country = ref.country;
    var result = [
        city === null || city === void 0 ? void 0 : city[language],
        country === null || country === void 0 ? void 0 : country[language]
    ];
    return result.filter(Boolean).join(", ");
};
var removeVideoConsultation = function(practice) {
    return practice.slug !== "video-consultation";
};
var transformAddressToShortString = function(address, language) {
    var ref = address || {}, city = ref.city, postcode = ref.postcode;
    if (language === _constants_global__WEBPACK_IMPORTED_MODULE_0__/* .LANGUAGES.DE */ .a2.DE) {
        return [
            postcode === null || postcode === void 0 ? void 0 : postcode[language],
            city === null || city === void 0 ? void 0 : city[language]
        ].filter(function(v) {
            return !!v;
        }).join(", ");
    }
    return [
        city === null || city === void 0 ? void 0 : city[language],
        postcode === null || postcode === void 0 ? void 0 : postcode[language]
    ].filter(function(v) {
        return !!v;
    }).join(", ");
};
var getAddressFromPractices = function(practices, sortByDistance) {
    var hideVideoConsultation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var ref, ref1;
    var filteredWithAddress = hideVideoConsultation ? practices === null || practices === void 0 ? void 0 : practices.filter(removeVideoConsultation) : practices;
    return sortByDistance ? (ref = filteredWithAddress === null || filteredWithAddress === void 0 ? void 0 : filteredWithAddress.sort(function(a, b) {
        return a.distance - b.distance;
    })[0]) === null || ref === void 0 ? void 0 : ref.address : filteredWithAddress === null || filteredWithAddress === void 0 ? void 0 : (ref1 = filteredWithAddress[0]) === null || ref1 === void 0 ? void 0 : ref1.address;
};


/***/ }),

/***/ 10415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ GoogleRecaptcha; }
/* harmony export */ });
/* harmony import */ var _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5001);
/* harmony import */ var _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var GoogleRecaptcha = /*#__PURE__*/ function() {
    "use strict";
    function GoogleRecaptcha(captchaKey) {
        _classCallCheck(this, GoogleRecaptcha);
        this.captchaKey = captchaKey;
        this.init();
    }
    var _proto = GoogleRecaptcha.prototype;
    _proto.init = function init() {
        if (true) {
            if (this.captchaKey) {
                var scriptSrc = "https://www.google.com/recaptcha/api.js?render=".concat(this.captchaKey);
                var exists = Array.from(document.scripts).find(function(script) {
                    return script.src === scriptSrc;
                });
                if (!exists) {
                    var script1 = document.createElement("script");
                    script1.type = "text/javascript";
                    script1.src = scriptSrc;
                    document.head.appendChild(script1);
                }
            } else {
                console.info("Captcha key is not specified");
            }
        }
    };
    _proto.handleWithValidation = function handleWithValidation(handler) {
        var _this = this;
        return _asyncToGenerator(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var headers, token;
            return _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        headers = {
                            "google-recaptcha-token": "",
                            "google-recaptcha-site-id": _this.captchaKey || ""
                        };
                        if (!( true && window.grecaptcha && _this.captchaKey)) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.next = 4;
                        return new Promise(function(resolve) {
                            return window.grecaptcha.ready(resolve);
                        });
                    case 4:
                        _ctx.next = 6;
                        return window.grecaptcha.execute(_this.captchaKey, {
                            action: "submit"
                        });
                    case 6:
                        token = _ctx.sent;
                        headers["google-recaptcha-token"] = token;
                        if (handler) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", headers);
                    case 10:
                        return _ctx.abrupt("return", handler(headers));
                    case 11:
                        return _ctx.abrupt("return", handler ? handler({}) : {});
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GoogleRecaptcha;
}();


/***/ }),

/***/ 12814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "iD": function() { return /* binding */ isOlderThanNMonth; },
/* harmony export */   "nr": function() { return /* binding */ getReviewDate; },
/* harmony export */   "qW": function() { return /* binding */ getYearsDiff; },
/* harmony export */   "tb": function() { return /* binding */ getDateWithOffset; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87530);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79014);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55466);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_2__);



dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_1___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_2___default()));
var getYearsDiff = function(date) {
    if (!date) {
        return null;
    }
    var todayFullYear = dayjs__WEBPACK_IMPORTED_MODULE_0___default()();
    if (typeof date === "string") {
        var splitDate = date.split("-");
        var dateFullYear = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date, Number(splitDate[0]) > Number(splitDate[2]) ? "MM-DD-YYYY" : "DD-MM-YYYY");
        return Number(todayFullYear.diff(dateFullYear, "year").toString());
    }
    var dateFullYear1 = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date, "MM-DD-YYYY");
    return Number(todayFullYear.diff(dateFullYear1, "year").toString());
};
var getReviewDate = function(date, utc) {
    if (!date) {
        return "";
    }
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date, {
        utc: utc
    }).format("DD MMM YYYY");
};
var isOlderThanNMonth = function(nMonth, date) {
    if (!date) {
        return false;
    }
    var dateNMonthAgo = dayjs__WEBPACK_IMPORTED_MODULE_0___default()().subtract(nMonth, "month");
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).isBefore(dateNMonthAgo);
};
function getDateWithOffset(offsetDays) {
    var date = new Date();
    date.setDate(date.getDate() + offsetDays);
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, "0");
    var day = String(date.getDate()).padStart(2, "0");
    return "".concat(year, "-").concat(month, "-").concat(day);
}


/***/ }),

/***/ 76868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ getAbbreviation; }
/* harmony export */ });
var getFirstLetterInUpperCase = function(str, language) {
    return (str[language] || str.en)[0].toUpperCase() || "";
};
var getAbbreviation = function(param) {
    var practice = param.practice, specialist = param.specialist, language = param.language;
    if (practice) {
        return getFirstLetterInUpperCase(practice.name, language);
    }
    return getFirstLetterInUpperCase(specialist.firstName, language) + getFirstLetterInUpperCase(specialist === null || specialist === void 0 ? void 0 : specialist.lastName, language);
};


/***/ }),

/***/ 57947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O8": function() { return /* binding */ parseParamsFromPath; },
/* harmony export */   "aR": function() { return /* binding */ transformToQuery; },
/* harmony export */   "p9": function() { return /* binding */ parseQueryFromString; }
/* harmony export */ });
var transformToQuery = function(data) {
    var params = new URLSearchParams();
    Object.keys(data).forEach(function(key) {
        var value = data[key];
        if (value && !Array.isArray(value) || value && Array.isArray(value) && value.length) {
            if (Array.isArray(value)) {
                return value.forEach(function(item) {
                    if (item) {
                        params.append("".concat(key, "[]"), String(item));
                    }
                });
            }
            if (key === "keyword") {
                return params.append(key, '"'.concat(String(value), '"'));
            }
            return params.append(key, String(value));
        }
        return null;
    });
    return params.toString();
};
var parseQueryFromString = function(url) {
    var withProtocol = (url === null || url === void 0 ? void 0 : url.includes("http://")) || (url === null || url === void 0 ? void 0 : url.includes("https://"));
    var parsedUrl = new URL(url !== null && url !== void 0 ? url : "", !withProtocol ? "http://test.com" : undefined);
    return Object.fromEntries(parsedUrl.searchParams);
};
var parseParamsFromPath = function(path) {
    return path.split("/").slice(1);
};


/***/ }),

/***/ 43601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A5": function() { return /* binding */ compareStrings; },
/* harmony export */   "Ig": function() { return /* binding */ capitalise; },
/* harmony export */   "aS": function() { return /* binding */ truncateString; },
/* harmony export */   "eV": function() { return /* binding */ camelCase; },
/* harmony export */   "i": function() { return /* binding */ removeSpecificSymbols; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toArray(arr) {
    return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var capitalise = function(value) {
    if (!value) {
        return "";
    }
    var ref = _toArray(value.split("")), firstLetter = ref[0], restLitters = ref.slice(1);
    return [
        firstLetter.toUpperCase()
    ].concat(_toConsumableArray(restLitters)).join("");
};
/**
 * Truncates the given string to a maximum number of words or length, if necessary.
 *
 * @param {string} str - The string to truncate.
 * @param {number} [maxAmountWords=15] - The maximum number of words that can be returned. Default is 15.
 * @param {number} [maxStringLength=100] - The maximum length of the string that can be returned. Default is 100.
 * @param {string} [suffix='...'] - The string to append to the end of the truncated string. Default is '...'.
 *
 * @returns {string} - The truncated string.
 */ var truncateString = function(str) {
    var maxAmountWords = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 15, maxStringLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100, suffix = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "...";
    if (str.length <= maxStringLength && str.split(" ").length <= maxAmountWords) {
        return str;
    }
    return str.split(" ").reduce(function(prev, curr, index) {
        return prev.length + curr.length <= maxStringLength - suffix.length && index <= maxAmountWords ? "".concat(prev, " ").concat(curr) : prev;
    }, "") + suffix;
};
var compareStrings = function(sample) {
    for(var _len = arguments.length, strings = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        strings[_key - 1] = arguments[_key];
    }
    return strings.every(function(value) {
        return value.toLowerCase() === sample.toLowerCase();
    });
};
var camelCase = function(str) {
    return str === null || str === void 0 ? void 0 : str.replace(/[^a-zA-Z0-9]+(.)/g, function(_, chr) {
        return chr.toUpperCase();
    }).replace(/^[^a-zA-Z0-9]+/, "").replace(/[^a-zA-Z0-9]/g, "").replace(/^./, function(match) {
        return match.toLowerCase();
    });
};
var removeSpecificSymbols = function(str) {
    return str.replace(/[^\S\r\n\x21-\x7E\u00A0-\uFFFF ]/g, "");
};


/***/ })

}]);